(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["renolivo-contact-widget"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const widget=document.querySelector('[data-rnl-contact]');if(!widget)return;const toggle=widget.querySelector('.rnl-contact-toggle');const panel=widget.querySelector('.rnl-contact-panel');if(event.target.closest('.rnl-contact-toggle')){const opening=panel.hidden;panel.hidden=!opening;toggle.setAttribute('aria-expanded',String(opening));if(opening)panel.querySelector('.rnl-contact-close').focus();}else if(event.target.closest('.rnl-contact-close')||(!widget.contains(event.target)&&!panel.hidden)){panel.hidden=true;toggle.setAttribute('aria-expanded','false');if(event.target.closest('.rnl-contact-close'))toggle.focus();}});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const widget=document.querySelector('[data-rnl-contact]');if(!widget)return;const panel=widget.querySelector('.rnl-contact-panel');if(!panel.hidden){panel.hidden=true;const toggle=widget.querySelector('.rnl-contact-toggle');toggle.setAttribute('aria-expanded','false');toggle.focus();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["renolivo-page-nav"] && !Shopify.designMode) return;
  try {
    function initRenolivoPageNav() {
    document.querySelectorAll('[data-rnl-page-nav]').forEach((navigation) => {
      if (navigation.dataset.ready) return;
      const content = document.getElementById(navigation.dataset.rnlPageNav);
      if (!content) return;
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length < 3) return;
      const list = navigation.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${content.id}-topic-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      navigation.dataset.ready = 'true';
      navigation.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRenolivoPageNav, {once:true});
  else initRenolivoPageNav();
  document.addEventListener('shopify:section:load', initRenolivoPageNav);
  } catch(e) { console.error(e); }
})();

})();
